export const VERSION = "1.4.0";


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = PNE4
// module chunks = 4